<template>
  <div :class="['text-block', {'text-block--center': centered ,'text-block--last': last}]">
    <p v-for="paragraph, index in paras" :key="index"
      :class="['text-block__content', {'u-text-black': !darkBG, 'u-text-white': darkBG, 'text-block__content--last': index == paras.length - 1, 'text-block__content--large': textLarge}]"
      v-html="paragraph"></p>
  </div>
</template>

<script>
export default {
  props: {
    darkBG: {
      type: Boolean,
      default: false
    },
    paras: {
      type: Array,
      required: false,
    },
    textLarge: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.ras-main {
  .text-block {
    margin-bottom: 25px;

    @media (min-width: map_get($breakpoints, md)) {
      margin-bottom: 50px;
    }

    p.text-block__content {
      font-family: $ff-sans;
      font-size: 15px;
      line-height: 1.5;
      margin-bottom: 20px;

      @media (min-width: map_get($breakpoints, md)) {
        font-size: 18px;
        text-align: left;
      }

      &--large {
        font-size: 18px;

        @media (min-width: map_get($breakpoints, md)) {
          font-size: 21px;
        }
      }

      &--last {
        margin-bottom: 0;
      }
    }

    &--center {
      p.text-block__content {
        text-align: center;

        @media (min-width: map_get($breakpoints, md)) {
          text-align: center;
        }
      }
    }


    &--last {
      margin-bottom: 0;
    }
  }
}
</style>
